/* TBET — Free-Shipping-Indicator V2 („5B Editorial")
 *
 * Zwei-Stagen-Mechanik:
 *   Stage 1: 0 → €80  (100% des Balkens = Free Shipping)
 *   Unlock:  Leiste wird schwarz + wächst, "Free shipping unlocked."
 *            Danach skaliert der Balken auf €150 um (steht bei ~53%),
 *            Kerbe markiert den geschafften Checkpoint.
 *   Stage 2: €80 → €150 (Free TBET Bag — limited skull print, not for sale)
 *
 * Verhalten:
 *   - Beträge zählen per rAF hoch (700ms, ease-out) statt zu springen
 *   - Jeder Unlock feuert exakt EINMAL (Guards; bei Reload mit vollem
 *     Warenkorb wird der Zustand still gesetzt, keine Replays)
 *   - Add ohne Unlock → Restbetrag pulst kurz (Nudge)
 *   - < €20 bis zum nächsten Ziel → "ALMOST THERE" + blinkender Caret
 *
 * Integration wie V1: hängt sich an fetch/XHR-Cart-Mutationen und
 * an das 'cart:updated'-Event. Boot über /cart.js.
 * Erwartet das Markup aus snippets/tbet-shipping-indicator-v2.liquid.
 */
(function () {
  'use strict';

  function $(sel, root) { return (root || document).querySelector(sel); }

  var FLASH_MS = 1950;
  var PHASE_DELAY_MS = 1300;
  var COUNT_MS = 700;
  var CLOSE_MARGIN = 20;

  function SI2() {
    this.el = $('[data-shipping-indicator-v2]');
    this.ticker = $('[data-promo-ticker]');
    if (!this.el) return;

    this.ship = parseFloat(this.el.getAttribute('data-threshold-ship')) || 80;
    this.bag = parseFloat(this.el.getAttribute('data-threshold-bag'));
    if (isNaN(this.bag)) this.bag = 0;
    /* Bag-Threshold 0 (oder <= Free-Shipping-Schwelle) = Checkpoint 2 deaktiviert */
    this.giftMode = this.bag > this.ship;
    this.cur = this.el.getAttribute('data-currency') || '\u20AC';
    var bagImg = this.el.getAttribute('data-bag-image') || '';

    this._left = $('.tbet-si2__left', this.el);
    this._next = $('.tbet-si2__next', this.el);
    this._track = $('.tbet-si2__track', this.el);
    this._fill = $('.tbet-si2__fill', this.el);
    this._notch = $('.tbet-si2__notch', this.el);
    this._caret = $('.tbet-si2__caret', this.el);
    this._stub = $('.tbet-si2__stub', this.el);
    this._hintText = $('.tbet-si2__hint-text', this.el);
    this._hintImg = $('.tbet-si2__hint-img', this.el);
    this._flashEl = $('.tbet-si2__flash', this.el);
    this._flashImg = $('.tbet-si2__flash-img', this.el);
    this._flashLine = $('.tbet-si2__flash-line', this.el);
    this._flashSub = $('.tbet-si2__flash-sub', this.el);

    if (bagImg) {
      if (this._hintImg) this._hintImg.src = bagImg;
      if (this._flashImg) this._flashImg.src = bagImg;
    }
    if (this._notch && this.giftMode) this._notch.style.left = ((this.ship / this.bag) * 100).toFixed(2) + '%';
    if (!this.giftMode) {
      var hintRow = $('.tbet-si2__hint', this.el);
      if (hintRow) hintRow.style.display = 'none';
      if (this._stub) this._stub.style.display = 'none';
    }

    this.total = 0;
    this.shown = 0;
    this.phase = 1;
    this.shipDone = false;
    this.bagDone = false;
    this.booted = false;

    this._hookCartEvents();
    this._installFetchInterceptor();
    this._installXHRInterceptor();
    this._trackStripHeight();
    this._checkInitialState();
  }

  /* Haelt --tbet-strip-h aktuell, damit die sticky Nav exakt unter der
     Leiste andockt (Ticker 32px / Bar 78px / Flash 106px). */
  SI2.prototype._trackStripHeight = function () {
    var wrap = this.el.closest('.shopify-section');
    if (!wrap) return;
    function set() {
      document.documentElement.style.setProperty('--tbet-strip-h', wrap.offsetHeight + 'px');
    }
    if ('ResizeObserver' in window) {
      new ResizeObserver(set).observe(wrap);
    } else {
      window.addEventListener('resize', set);
    }
    set();
  }

  /* ---------- Cart update ---------------------------------------------- */
  SI2.prototype.onCartUpdate = function (cart, opts) {
    if (!cart) return;
    var silent = opts && opts.silent;
    var total = (cart.total_price || 0) / 100;
    var itemCount = cart.item_count || 0;

    this._updateBagText(itemCount, total);

    if (itemCount === 0) {
      this._showTicker();
      this.total = 0; this.shown = 0;
      this.phase = 1; this.shipDone = false; this.bagDone = false;
      return;
    }

    this._showIndicator();

    if (silent || !this.booted) {
      // Reload / Boot: Zustand ohne Animation setzen, keine Unlock-Replays
      this.booted = true;
      this.total = total;
      this.shown = total;
      if (total >= this.ship) { this.shipDone = true; if (this.giftMode) this.phase = 2; }
      if (this.giftMode && total >= this.bag) { this.bagDone = true; }
      this._render();
      return;
    }

    var crosses = (!this.shipDone && total >= this.ship) ||
                  (this.giftMode && !this.bagDone && total >= this.bag);
    if (!crosses && total > this.total) this._nudge();

    this.total = total;
    this._animateTo(total);
  };

  /* ---------- Count-up + Unlock-Erkennung ------------------------------ */
  SI2.prototype._animateTo = function (target) {
    if (this._raf) cancelAnimationFrame(this._raf);
    var start = this.shown;
    var t0 = performance.now();
    var self = this;
    function step(now) {
      var p = Math.min(1, (now - t0) / COUNT_MS);
      var e = 1 - Math.pow(1 - p, 3);
      self.shown = start + (target - start) * e;
      if (!self.shipDone && self.shown >= self.ship) {
        self.shipDone = true;
        self._flash(false);
        if (self.giftMode) {
          self._phaseT = setTimeout(function () {
            self.phase = 2;
            self._trackIn();
            self._render();
          }, PHASE_DELAY_MS);
        }
      }
      if (self.giftMode && !self.bagDone && self.shown >= self.bag) {
        self.bagDone = true;
        self._flash(true);
      }
      self._render();
      if (p < 1) self._raf = requestAnimationFrame(step);
    }
    this._raf = requestAnimationFrame(step);
  };

  /* ---------- Render ---------------------------------------------------- */
  SI2.prototype._render = function () {
    var s = this.shown;
    var pct = this.phase === 1
      ? Math.min(1, s / this.ship) * 100
      : Math.min(1, s / this.bag) * 100;
    if (this._fill) this._fill.style.width = pct.toFixed(2) + '%';

    var left, next;
    if (!this.giftMode) {
      /* Ein-Stufen-Modus: nur Free Shipping */
      if (s < this.ship) {
        left = this.cur + Math.round(s) + ' / ' + this.cur + this.ship;
        next = '+' + this.cur + Math.max(0, Math.ceil(this.ship - s)) + ' TO FREE SHIPPING';
        var remain1 = this.ship - s;
        if (s > 0 && remain1 > 0 && remain1 <= CLOSE_MARGIN) next = 'ALMOST THERE \u2014 ' + next;
      } else {
        left = 'FREE SHIPPING \u25CF';
        next = 'DHL \u00B7 GERMANY \u00B7 NO CODE NEEDED';
      }
      if (this._left) this._left.textContent = left;
      if (this._next) this._next.textContent = next;
      if (this._notch) this._notch.hidden = true;
      if (this._caret) {
        var close1 = s > 0 && s < this.ship && (this.ship - s) <= CLOSE_MARGIN;
        this._caret.hidden = !close1;
        this._caret.style.left = pct.toFixed(2) + '%';
      }
      return;
    }
    if (this.phase === 1) {
      left = this.cur + Math.round(s) + ' / ' + this.cur + this.ship;
      next = '+' + this.cur + Math.max(0, Math.ceil(this.ship - s)) + ' TO FREE SHIPPING';
    } else if (s < this.bag) {
      left = 'FREE SHIPPING \u25CF \u00B7 ' + this.cur + Math.round(s) + ' / ' + this.cur + this.bag;
      next = '+' + this.cur + Math.ceil(this.bag - s) + ' TO FREE TBET BAG';
    } else {
      left = 'FREE SHIPPING \u25CF \u00B7 ' + this.cur + Math.round(s);
      next = 'FREE SHIPPING + FREE TBET BAG \u25CF\u25CF';
    }

    var remain = this.phase === 1 ? this.ship - s : this.bag - s;
    var close = s > 0 && remain > 0 && remain <= CLOSE_MARGIN;
    if (close) next = 'ALMOST THERE \u2014 ' + next;

    if (this._left) this._left.textContent = left;
    if (this._next) this._next.textContent = next;

    if (this._stub) this._stub.style.display = this.phase === 1 ? '' : 'none';
    if (this._notch) this._notch.hidden = this.phase !== 2;
    if (this._caret) {
      this._caret.hidden = !close;
      this._caret.style.left = pct.toFixed(2) + '%';
    }

    var hint;
    if (this.bagDone) {
      hint = 'TBET BAG UNLOCKED \u25CF LIMITED SKULL PRINT';
    } else if (this.phase === 2) {
      hint = 'TBET BAG (LIMITED SKULL PRINT) \u2014 NOT FOR SALE';
    } else {
      hint = 'THEN: TBET BAG (LIMITED SKULL PRINT) \u2014 NOT FOR SALE';
    }
    if (this._hintText) this._hintText.textContent = hint;
    if (this._hintImg) this._hintImg.classList.toggle('is-unlocked', this.bagDone);
  };

  /* ---------- Unlock-Flash (Editorial-Moment) --------------------------- */
  SI2.prototype._flash = function (isBag) {
    var self = this;
    if (this._flashT) clearTimeout(this._flashT);
    if (this._flashLine) this._flashLine.textContent = isBag ? 'Free TBET bag unlocked.' : 'Free shipping unlocked.';
    if (this._flashSub) this._flashSub.textContent = isBag
      ? 'NOT FOR SALE \u2014 UNLOCK ONLY \u00B7 ADDED AT CHECKOUT'
      : 'DHL \u00B7 GERMANY \u00B7 NO CODE NEEDED';
    if (this._flashImg) this._flashImg.hidden = !isBag;
    // Ist die Leiste aus dem Viewport gescrollt (v. a. mobil), zeigen wir den
    // Flash als fixiertes Overlay am oberen Rand — sonst sieht man den Moment nie.
    this.el.classList.toggle('tbet-si2--viewport', window.scrollY > 40);
    // Attribut kurz entfernen + neu setzen, damit die Animationen sauber neu starten
    this.el.removeAttribute('data-flash');
    void this.el.offsetWidth;
    this.el.setAttribute('data-flash', '');
    this._flashT = setTimeout(function () {
      self.el.removeAttribute('data-flash');
      self.el.classList.remove('tbet-si2--viewport');
    }, FLASH_MS);
  };

  SI2.prototype._trackIn = function () {
    var self = this;
    if (!this._track) return;
    this._track.classList.remove('is-new');
    void this._track.offsetWidth;
    this._track.classList.add('is-new');
    setTimeout(function () { self._track.classList.remove('is-new'); }, 900);
  };

  SI2.prototype._nudge = function () {
    var self = this;
    if (!this._next) return;
    if (this._nudgeT) clearTimeout(this._nudgeT);
    this._next.classList.remove('is-nudge');
    void this._next.offsetWidth;
    this._next.classList.add('is-nudge');
    this._nudgeT = setTimeout(function () { self._next.classList.remove('is-nudge'); }, 550);
  };

  /* ---------- Sichtbarkeit Indicator vs. Promo-Ticker ------------------- */
  SI2.prototype._showIndicator = function () {
    this.el.style.display = '';
    this.el.setAttribute('aria-hidden', 'false');
    if (this.ticker) {
      this.ticker.style.display = 'none';
      this.ticker.setAttribute('aria-hidden', 'true');
    }
  };
  SI2.prototype._showTicker = function () {
    this.el.style.display = 'none';
    this.el.setAttribute('aria-hidden', 'true');
    if (this.ticker) {
      this.ticker.style.display = '';
      this.ticker.setAttribute('aria-hidden', 'false');
    }
  };

  /* ---------- Bag-Link-Texte (wie V1) ----------------------------------- */
  SI2.prototype._updateBagText = function (itemCount, total) {
    var mainEls = document.querySelectorAll('[data-tbet-bag-main]');
    var suffixEls = document.querySelectorAll('[data-tbet-bag-suffix]');
    mainEls.forEach(function (el) {
      var current = el.textContent || 'Bag';
      var base = current.replace(/^Empty\s+/i, '').replace(/\s*\([^)]*\).*$/, '').trim() || 'Bag';
      el.textContent = itemCount === 0 ? 'Empty ' + base + ' (0)' : base + ' (' + itemCount + ')';
    });
    var showSuffix = itemCount > 0 && total >= this.ship;
    suffixEls.forEach(function (el) {
      if (showSuffix) {
        el.removeAttribute('hidden');
        if (!el.textContent || !el.textContent.trim()) el.textContent = 'Free Shipping Unlocked';
      } else {
        el.setAttribute('hidden', '');
      }
    });
  };

  /* ---------- Boot + Cart-Hooks (identisch zu V1) ------------------------ */
  SI2.prototype._checkInitialState = function () {
    var self = this;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { self.onCartUpdate(cart, { silent: true }); })
      .catch(function () { self.booted = true; /* offline/Demo — bleibt EMPTY */ });
  };

  SI2.prototype._hookCartEvents = function () {
    var self = this;
    document.addEventListener('cart:updated', function (e) {
      var cart = (e && e.detail && e.detail.cart) || null;
      if (cart) self.onCartUpdate(cart);
      else self._refetch();
    });
    document.addEventListener('cart-update', function () { self._refetch(); });
  };

  SI2.prototype._refetch = function () {
    var self = this;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { self.onCartUpdate(cart); })
      .catch(function () {});
  };

  SI2.prototype._installFetchInterceptor = function () {
    var self = this;
    var originalFetch = window.fetch;
    if (!originalFetch) return;
    window.fetch = function () {
      var url = arguments[0];
      var urlStr = typeof url === 'string' ? url : (url && url.url) || '';
      var isCartMutation = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/i.test(urlStr);
      var p = originalFetch.apply(window, arguments);
      if (isCartMutation) {
        p.then(function () { setTimeout(function () { self._refetch(); }, 80); }).catch(function () {});
      }
      return p;
    };
  };

  SI2.prototype._installXHRInterceptor = function () {
    var self = this;
    var XHR = window.XMLHttpRequest;
    if (!XHR) return;
    var origOpen = XHR.prototype.open;
    var origSend = XHR.prototype.send;
    XHR.prototype.open = function (method, url) {
      this._tbetCartUrl = url || '';
      return origOpen.apply(this, arguments);
    };
    XHR.prototype.send = function () {
      var self2 = this;
      this.addEventListener('load', function () {
        var url = self2._tbetCartUrl || '';
        if (/\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/i.test(url)) {
          setTimeout(function () { self._refetch(); }, 80);
        }
      });
      return origSend.apply(this, arguments);
    };
  };

  /* ---------- Boot ------------------------------------------------------- */
  function boot() {
    if (window.tbetShippingIndicatorV2) return;
    var node = $('[data-shipping-indicator-v2]');
    if (!node) return;
    window.tbetShippingIndicatorV2 = new SI2();
  }
  window.tbetSI2Boot = boot;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
